import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {PaypalRequestsFilter} from './PaypalRequestsFilter.js';
import {PaypalRequestsTable} from './PaypalRequestsTable';
import {PaypalRequestsFooter} from './PaypalRequestsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function PaypalRequestsCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'paypal-requests-list-card'}>
      <PaypalRequestsFilter/>
      <PaypalRequestsTable/>
      <FooterBar>
        <PaypalRequestsFooter/>
      </FooterBar>
    </Card>
  );
}
